import { render, staticRenderFns } from "./semp-add.vue?vue&type=template&id=bff72f94&scoped=true&"
import script from "./semp-add.vue?vue&type=script&lang=js&"
export * from "./semp-add.vue?vue&type=script&lang=js&"
import style0 from "./semp-add.vue?vue&type=style&index=0&id=bff72f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff72f94",
  null
  
)

export default component.exports